import React, { useEffect, useState } from 'react';
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import socket from './socket';
import LiveScoreboardPanel from './liveScoreboardPanel';
import './App.css';

// Public, unauthenticated display page (meant for a venue TV/kiosk).
// Shows one board if a single game is live, two side-by-side if two are live.
const LiveDisplay = () => {
   const [activeGames, setActiveGames] = useState([]);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState('');

   const fetchActiveGames = async () => {
      try {
         const response = await fetch('/games/active');
         if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
         }
         const data = await response.json();
         setActiveGames(data.activeGames || []);
         setError('');
      } catch (err) {
         console.error('Error fetching active games:', err);
         setError('Failed to load the live display. Retrying shortly...');
      } finally {
         setLoading(false);
      }
   };

   useEffect(() => {
      fetchActiveGames();

      socket.on('activeGamesChanged', fetchActiveGames);

      // Safety-net poll in case an activeGamesChanged event is ever missed.
      const interval = setInterval(fetchActiveGames, 30000);

      return () => {
         socket.off('activeGamesChanged', fetchActiveGames);
         clearInterval(interval);
      };
   }, []);

   return (
      <div style={{ flexGrow: 1 }}>
         <Grid container spacing={3}>
            {/* Header - matches the site's header-footer-style used everywhere else */}
            <Grid item xs={12}>
               <Paper className="header-footer-style">
                  <Typography component={'span'}>
                     <h1>High Score Challenge</h1>
                  </Typography>
               </Paper>
            </Grid>

            {/* Main Content Area */}
            <Grid item xs={12}>
               <Paper className="main-style">
                  <Typography component={'span'}>
                     <div className="fade-in full-width">
                        {loading && <p className="text-center">Loading live scoreboard...</p>}

                        {!loading && error && (
                           <div className="error-message text-center margin-top-medium">{error}</div>
                        )}

                        {!loading && !error && activeGames.length === 0 && (
                           <div className="text-center margin-top-medium">
                              <p>No game is currently live. Check back soon!</p>
                           </div>
                        )}

                        {!loading && !error && activeGames.length > 0 && (
                           <div className={activeGames.length === 2 ? 'dual-scoreboard-container' : 'single-scoreboard-container'}>
                              {activeGames.map((game) => (
                                 <div className="scoreboard-wrapper" key={game.id}>
                                    <LiveScoreboardPanel game={game} />
                                 </div>
                              ))}
                           </div>
                        )}
                     </div>
                  </Typography>
               </Paper>
            </Grid>
         </Grid>
      </div>
   );
};

export default LiveDisplay;
